import { IUserRoles } from 'redux/user/user.types';

export const rolesHierarchy: IUserRoles[] = [
  IUserRoles.admin,
  IUserRoles.accountant,
  IUserRoles.analytic,
  IUserRoles.operator,
  IUserRoles.trainee,
  IUserRoles.HR,
  IUserRoles.salesHeadManager,
  IUserRoles.attractionHeadManager,
  IUserRoles.attractionManager,
  IUserRoles.developmentDirector,
  IUserRoles.developmentDirectorDeputy,
  IUserRoles.headOfAttractionDepartment,
  IUserRoles.manager,
  IUserRoles.regionalDirector,
  IUserRoles.groupOfRegionDirector,
  // чем ниже, тем меньше прав
];

export const canAssignRole = (currentRole: IUserRoles, targetRole: IUserRoles): boolean => {
  if (currentRole === IUserRoles.admin || currentRole === IUserRoles.developmentDirector) {
    return true;
  }

  const currentIndex = rolesHierarchy.indexOf(currentRole);
  const targetIndex = rolesHierarchy.indexOf(targetRole);

  return currentIndex > -1 && targetIndex > -1 && currentIndex > targetIndex;
};
